/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_SettingsInputs */

const th_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตั้งค่า`)
};

const en_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const ja_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const zh_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置`)
};

const es_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

const pt_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações`)
};

const id_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan`)
};

const fr_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglages`)
};

const tl_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga setting`)
};

const vi_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiết lập`)
};

const ko_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정`)
};

const de_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const ru_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки`)
};

const tr_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayarlar`)
};

const it_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

const pl_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia`)
};

const uk_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Налаштування`)
};

const hi_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स`)
};

const ar_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعدادات`)
};

const ms_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapan`)
};

const bn_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেটিংস`)
};

const zh_tw2_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const zh_hk2_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const ur_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتیبات`)
};

const fa_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنظیمات`)
};

const sw_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mipangilio`)
};

const nl_tab_settings = /** @type {(inputs: Tab_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instellingen`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Tab_SettingsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_settings = /** @type {((inputs?: Tab_SettingsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_SettingsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_settings(inputs)
	if (locale === "ja") return ja_tab_settings(inputs)
	if (locale === "zh") return zh_tab_settings(inputs)
	if (locale === "es") return es_tab_settings(inputs)
	if (locale === "pt") return pt_tab_settings(inputs)
	if (locale === "id") return id_tab_settings(inputs)
	if (locale === "fr") return fr_tab_settings(inputs)
	if (locale === "tl") return tl_tab_settings(inputs)
	if (locale === "vi") return vi_tab_settings(inputs)
	if (locale === "ko") return ko_tab_settings(inputs)
	if (locale === "de") return de_tab_settings(inputs)
	if (locale === "ru") return ru_tab_settings(inputs)
	if (locale === "tr") return tr_tab_settings(inputs)
	if (locale === "it") return it_tab_settings(inputs)
	if (locale === "pl") return pl_tab_settings(inputs)
	if (locale === "uk") return uk_tab_settings(inputs)
	if (locale === "hi") return hi_tab_settings(inputs)
	if (locale === "ar") return ar_tab_settings(inputs)
	if (locale === "ms") return ms_tab_settings(inputs)
	if (locale === "bn") return bn_tab_settings(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_settings(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_settings(inputs)
	if (locale === "ur") return ur_tab_settings(inputs)
	if (locale === "fa") return fa_tab_settings(inputs)
	if (locale === "sw") return sw_tab_settings(inputs)
	if (locale === "nl") return nl_tab_settings(inputs)
	return en_tab_settings(inputs)
});